import { render } from "./Parts.vue?vue&type=template&id=490cf537&scoped=true"
import script from "./Parts.vue?vue&type=script&lang=js"
export * from "./Parts.vue?vue&type=script&lang=js"

import "./Parts.vue?vue&type=style&index=0&id=490cf537&scoped=true&lang=css"

import exportComponent from "E:\\Vue_Project\\JamoatFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490cf537"]])

export default __exports__